import { RefObject, useCallback, useEffect } from 'react';

interface Props {
    open: boolean;
    onOpenChange: () => void;
    buttonRef: RefObject<HTMLButtonElement>;
    menuRef: RefObject<HTMLDivElement>;
}

export const useDropdownOpenClose = ({ open, onOpenChange, buttonRef, menuRef }: Props) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                !menuRef.current?.contains(event.target as Node) &&
                !buttonRef.current?.contains(event.target as Node) &&
                open
            ) {
                onOpenChange();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open, onOpenChange, buttonRef, menuRef]);

    useEffect(() => {
        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && open) {
                event.preventDefault();
                onOpenChange();
                buttonRef.current?.focus();
            }
        };
        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [open, onOpenChange, buttonRef, menuRef]);

    const handleToggle = useCallback(() => {
        onOpenChange();
    }, [onOpenChange]);

    return { handleToggle };
};
